export const actions = {
  ATTACH_FILES: 'FILES:ATTACH_FILES',
  REMOVE_FILE: 'FILES:REMOVE_FILE',
};

export function attachFiles(inputHandle, files) {
  return {
    type: actions.ATTACH_FILES,
    payload: {inputHandle, files},
  };
}

export function removeFile(inputHandle, file) {
  return {
    type: actions.REMOVE_FILE,
    payload: {inputHandle, file},
  };
}
